module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_5012.eaf87529.png";